<template>
    <div class="navbar">

        <van-list>
            <van-cell v-for="item in list" :key="item" :title="item.name" class="menu-item"
                :class="{ selectLianjiuMenuItem: activeNames === item.id }" @click.native="handleFirst(item)" />
        </van-list>



    </div>
</template>

<script>
export default {

    data() {
        return {
            list: [],

            activeNames: [], // 更改为数组
        };
    },

    mounted() {
        this.getList()
    },

    methods: {
        //获取二级菜单列表
        async getList() {
            const { data } = await this.$fetch.get("/api/directory/navList");
            const arr = [];
            data.forEach(element => {
                let obj = element

                if (Array.isArray(obj.children)) {
                    // 过滤并保留 status 为 true 的项
                    obj.children = obj.children.filter(item2 => item2.status);
                }
                arr.push(element);
            });
            this.list = arr;
        },


        handleFirst(item) {
            if (item.children && item.children.length > 0) {
                const first = item.children[0];
                // 跳转特殊路由
                if(first.name === '讲师介绍' || first.name === '学习文档' ||first.name === '学习视频' ||first.name === '考核结果'){
                    this.$router.push({
                        path: `/topic/topic-teacher`,
                    });
                  } else {
                    const query = {
                        // name: first.name,
                        id: btoa(first.id),
                    };
                    this.toListRouter(query);
                  }
                this.$emit("update:visible", false)
                this.activeNames.push(item.id);


            }

        },
        toListRouter(query) {
            this.$router.push({
                path: `/article-list`,
                query,
            });
        },




    },
};
</script>

<style lang="less" scoped>
ul,
li {
    list-style: none;
}

.navbar {
    height: 100vh;
    width: 100vw;
    background-color: rgba(255, 255, 255, 0.8);
}


::v-deep .van-cell__title {
    font-size: 18px;
    padding: 4px 0;
    font-weight: bold;
}

::v-deep .van-cell {
    background-color: inherit;
}

.menu-item {
    * {
        color: #3560ab;
    }
}
</style>